import STYLE_MANAGER from "../../style-manager";

export class RedoDeliveryEstimateContainerElement extends HTMLElement {
  #deregisterStyles?: () => void;
  #deregisterModalStyles?: () => void;

  #root!: ShadowRoot;
  #modalContainer!: HTMLElement;

  get root() {
    return this.#root;
  }

  get modalContainer() {
    return this.#modalContainer;
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: "open" });
    this.#root = shadowRoot;
    this.#deregisterStyles = STYLE_MANAGER.register(shadowRoot);

    const modalRoot = this.ownerDocument.createElement("div");
    modalRoot.setAttribute("id", "redo-delivery-estimate-modal-root");
    modalRoot.style.display = "initial";
    modalRoot.style.position = "absolute";
    modalRoot.style.zIndex = "50000";
    document.body.append(modalRoot);
    const modalShadowRoot = modalRoot.attachShadow({ mode: "open" });
    this.#deregisterModalStyles = STYLE_MANAGER.register(modalShadowRoot);
    this.#modalContainer = this.ownerDocument.createElement("div");
    modalShadowRoot.append(this.#modalContainer);
  }

  disconnectedCallback() {
    this.#deregisterStyles?.();
    this.#deregisterModalStyles?.();
    this.#modalContainer?.remove();
  }

  static register() {
    try {
      if (!customElements.get(this.TAG)) {
        customElements.define(this.TAG, this);
      }
    } catch (error) {
      // Element might already be registered, which is fine
      // Continue execution to allow element creation
    }
  }

  static readonly TAG = "redo-delivery-estimate-container-element";
}
